import React from 'react'
import './resources/css/layout.css';
import {VERSION} from './Configuracion'
import {
    estadoChangePagina,
    PAGE_PRINCIPAL,
    PAGE_MARCAJE,
    PAGE_MARCAJERESULTADO, PAGE_MARCAJESDIA,
} from './redux/estado/actions'
import { connect } from 'react-redux';
import FormularioMarcaje from "./FormularioMarcaje";
import FormularioMarcajeResultado from "./FormularioMarcajeResultado";
import BarraEstado from "./BarraEstado";
import {encabezado} from "./Configuracion";
import PropTypes from "prop-types";


class Content extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    seleccionPagina= (pagina) => {
        this.props.dispatch(estadoChangePagina(pagina));
    }

    render() {
        const {sedeCodigo, terminalWebCodigo, estado} = this.props;
        console.log("XXXX CONTENT: sedeCodigo: ", sedeCodigo, " terminalWebCodigo:", terminalWebCodigo);
        return (
            <>
                <BarraEstado />
                <div className="content">
                    {estado && estado.pagina === PAGE_PRINCIPAL &&
                            <></>
                    }

                    {estado && estado.pagina === PAGE_MARCAJE &&
                    <FormularioMarcaje sedeCodigo={sedeCodigo} terminalWebCodigo={terminalWebCodigo}/>
                    }

                    {estado && estado.pagina === PAGE_MARCAJERESULTADO &&
                    <FormularioMarcajeResultado/>
                    }

                </div>
                { /*<BarraEstado />*/}
                <div>versión {VERSION} </div>
            </>

        );
    }
}

Content.propTypes = {
    sedeCodigo: PropTypes.number,
    terminalWebCodigo: PropTypes.number,
}

const mapStateToProps = function(state) {
    return {
        estado: state.estado,
    }
}

export default connect(mapStateToProps)(Content);

